import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    FRONT_EVENTS_SESION_SEATS_MAP: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.events.sesion.seats.map'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_TICKET_SEND: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.ticket.send'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_TICKET_SEND_WHATSAPP: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.ticket.send.whatsapp'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_TICKET_UPDATE: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.ticket.update'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_GET: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.get'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_UPDATE: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.update'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_ABONOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.abonos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_BASES: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.bases'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_BASE_RECIBO: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.base.recibo'), data, { responseType: 'blob' }).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_V2_PEDIDOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.v2.pedidos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_INVITACIONES: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.invitaciones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_PEDIDOS_ENTRADAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.pedidos.entradas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_MONEDEROS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.monederos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_INFORMACION_PAGO: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.info_pago'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_GET_JET_ID: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.get-jet-id'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PROCESAR_CONFIRMACION_TARJETA: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.procesar-confirmacion-tarjeta'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SELECT_PAISES: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('select.paises'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SELECT_MONEDAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('select.monedas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_SESION_DELETE: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.sesion.delete'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ABONOS_PRECIOS_CALCULAR_PRECIO: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonos.precios.calcular.precio'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BLOQUEAR_ABONOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bloquear.abonos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BLOQUEAR_ABONOS_PARKING: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bloquear.abonos-parking'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ABONOS_PRECIOS_INDEX: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonos.precios.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_RECINTO_SVG: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.recinto.svg'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_RECINTO_SVG_GENERAL: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.recinto.svg.general'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_RECINTO_SVG_BUTACAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.recinto.svg-butacas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EVENTO_SESION_RECINTO_BUTACAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.evento.sesion.butacas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_EVENTO_SESION_BLOQUEAR_BUTACAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.evento.sesion.bloquear-butacas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    EMAILS_BAJA: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('emails.baja'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    TRACKED_GA: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('tracked.ga'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    ZONAS_CALCULAR_PRECIO: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('zonas.calcular.precio'), data).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
    FRONT_ABONADOS_BUSAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonados.buscar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ABONADOS_IDENTIFICAR_INICIAL: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonados.identificar.inicial'), data).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
    FRONT_ABONADOS_BUSAR_AMIGO: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonados.buscar-amigo'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ABONOS_VALIDAR_MIEMBRO: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonos.validar-miembro'), data).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
    FRONT_ABONOS_AGREGAR_MIEMBRO: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonos.agregar-miembro'), data).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
    FRONT_ABONOS_REMOVER_MIEMBRO: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonos.remover-miembro'), data).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
    FRONT_ABONOS_CREAR_FAMILIA: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonos.crear-familia'), data).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
    FRONT_SESION_GET : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.sesion.get'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ZONAS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.zonas.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ZONAS_RECINTOS_ANEXOS_INDEX : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.zonas.recintos-anexos.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ZONAS_RECINTOS_ANEXOS_SHOW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.zonas.recintos-anexos.show'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ZONAS_SHOW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.zonas.show'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ZONAS_SVG : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.zonas.svg'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ZONAS_RECINTOS_ANEXOS_SVG : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.zonas.recintos-anexos.svg'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BLOQUEAR_ASIENTOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bloquear.asientos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_GUARDAR_DATOS_COMPRADOR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.guardar.datos.comprador'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_GUARDAR_DATOS_COMPRADOR_INTERNACIONAL : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.guardar.datos.comprador.internacional'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BORRAR_SESION : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.borrar.sesion'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_VOUCHER_BLOQUEAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.voucher.bloquear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_VOUCHER_DESBLOQUEAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.voucher.desbloquear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_GUARDAR_DATOS_RECORDATORIO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.recordatorios.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BASES_GUARDAR_DATOS_DEPORTISTA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bases.guardar-datos-deportista'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BASES_GUARDAR_DATOS_RESPONSABLES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bases.guardar-datos-responsables'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BASES_GUARDAR_DOCUMENTOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bases.guardar-documentos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BASES_GUARDAR_FOTO_PERFIL : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bases.guardar-foto-perfil'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BASES_BLOQUEAR_INDUMENTARIAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bases.bloquear-indumentarias'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BASES_GET_FORMULARIO_PAGO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bases.get-formulario-pago'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BASES_SESION_GET : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bases.sesion.get'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BASES_CALCULAR_PLAZOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bases.calcular-plazos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BASES_BORRAR_PLAZOS_CARRITO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bases.borrar-plazos-carrito'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BASES_EQUIPOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bases.equipos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BASES_VALIDAR_CODIGO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bases.validar_codigo'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BASES_BUSCAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bases.buscar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BASES_CODIGO_GET_CATEGORIA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bases.codigo.get-categoria'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PROCESAR_PAGO_NUEVO_ABONO: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonos.procesar-pago'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PROCESAR_PAGO_PAYCOMET: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.procesar-pago-paycomet'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_GET_PEDIDO_PROCESADO: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.get-pedido-procesado-paycomet'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PROCESAR_PAGO_BASE: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.bases.procesar-pago'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PROCESAR_PAGO_PLAZOS_PERFIL: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.procesar-pago-plazos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_GUARDAR_TERMINOS_CONDICIONES: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.guardar.terminos.condiciones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_ABONOS_ZONAS_RECINTOS_ANEXOS_INDEX: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonos.zonas.recintos-anexos.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_BUTACAS_ZONAS_RECINTOS_ANEXOS_INDEX: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.abonos.butacas.recintos-anexos.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_AFILIADOS_BUSCAR: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.afiliados.buscar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_ABONO_DESMARCAR_RENOVACION_AUTOMATICA: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.abono.desmarcar-renovacion-automatica'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_PEDIDOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.pedidos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_GET_SGA: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.get.sga'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_SGA_UPDATE: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.sga.update'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_ABONOS_SGA: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.abonos.sga'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_MEMBRESIAS_SGA: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.membresias.sga'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_PEDIDOS_SGA: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.pedidos.sga'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },

    FRONT_PERFIL_ABONOS_CAMBIAR_PIN: function({ commit }, data){
        return new Promise((resolve, reject) =>{
            api.call(config.getAPIRoute('front.perfil.abonos.cambiar-pin'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },

    

    FRONT_PERFIL_ABONO_SGA_TRANSFERIR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.abono.sga.transferir'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },

    FRONT_PERFIL_INVITACIONES_ABONADOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.invitaciones.abonados'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_INVITACIONES_ABONADOS_EVENTOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.invitaciones.abonados.eventos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_INVITACIONES_ABONADOS_CONSUMIDAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.invitaciones.abonados.consumidas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_INVITACIONES_ZONAS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.invitaciones.zonas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_INVITACIONES_ASIENTOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.invitaciones.asientos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_INVITACIONES_BLOQUEAR_ASIENTOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.invitaciones.bloquear-asientos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_INVITACIONES_GUARDAR_DATOS_COMPRADOR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.invitaciones.guardar-datos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_INVITACIONES_PROCESAR_COMPRA_SIN_GG: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.invitaciones.procesar-compra-sin-gg'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_PEDIDOS_DETALLE: function({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.pedidos.detalle'), data).then(data => {
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    FRONT_PERFIL_V2_PEDIDOS_DETALLE: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.v2.pedidos.detalle'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    FRONT_PERFIL_PEDIDOS_CARRITO_CREAR: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('front.perfil.pedidos.carrito.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    }
}

export default {
    actions
};
